import React from 'react'
import { SustainabilityPreAssessmentManagementStyled } from './styled'
import {
  Button,
  Modal,
  Image,
  Paginate,
  Section,
  SelectBox,
  Table,
  Switcher,
  Input,
  InputSearch,
} from '../../components'
import { ICONS, CONTENTS } from '../../themes'
import { ROUTE_PATH, redirect, STRING } from '../../helpers'

export class SustainabilityPreAssessmentManagementContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      modals: [{ name: 'delete', isOpen: false, Idlist: '', Fullname: '' }],
      mockUpData: [
        { id: '1', isActive: true },
        { id: '2', isActive: true },
        { id: '3', isActive: false },
      ],
      options: [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
      ],
      isSortBy: [
        { name: 'ID', value: undefined },
        { name: 'fileName', value: undefined },
      ],
    }
  }

  toggleSort = evt => {
    this.setState(prevState => ({
      ...prevState,
      isSortBy: prevState.isSortBy.map(column => ({
        ...column,
        value:
          column.name === evt
            ? column.value !== undefined
              ? column.value === 'asc'
                ? 'desc'
                : 'asc'
              : 'asc'
            : undefined,
      })),
    }))
  }

  filterSortByValue = evt => {
    return this.state.isSortBy
      .filter(columns => columns.name === evt)
      .map(column => column.value)[0]
  }

  handleActiveChange = evtID => {
    this.setState(
      prevState => ({
        ...prevState,
        mockUpData: prevState.mockUpData.map(mockUp => ({
          ...mockUp,
          isActive: mockUp.id === evtID ? !mockUp.isActive : mockUp.isActive,
        })),
      })
      // () => {
      //   console.log(this.state.bannerData)
      // }
    )
  }

  toggleModal = (evt, id, name) => {
    this.setState(
      prevState => ({
        ...prevState,
        modals: prevState.modals.map(modal => ({
          ...modal,
          isOpen: modal.name === id ? !modal.isOpen : false,
          Idlist: id,
          Fullname: name,
        })),
      })
      // () => {
      //   console.log(this.state.modals)
      // }
    )
  }

  render() {
    const { modals, mockUpData, options } = this.state

    return (
      <React.Fragment>
        <SustainabilityPreAssessmentManagementStyled>
          {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  id="page_icon_sustainability_pre_assessment_management"
                  src={ICONS['icon-badge-white.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section
                  id="page_title_sustainability_pre_assessment_management"
                  className="title"
                >
                  {STRING.SUSTAINABILITY_PRE_ASSESSMENT_MANAGEMENT}
                </Section>

                <Section
                  id="page_breadcrumb_sustainability_pre_assessment_management"
                  className="breadcrumbs"
                >
                  <Button
                    className="breadcrumb"
                    onClick={() => {
                      this.props.history.push(ROUTE_PATH.HOME.LINK)
                    }}
                  >
                    <span>{STRING.HOME}</span>
                  </Button>

                  <Button className="breadcrumb current">
                    <span>
                      {STRING.SUSTAINABILITY_PRE_ASSESSMENT_MANAGEMENT}
                    </span>
                  </Button>
                </Section>
              </Section>
            </Section>

            <Section className="page-button">
              <Button className="page-button" onClick={() => {}}>
                <Image src={ICONS['icon-upload.svg']} alt="add icon" />
                Upload Sustainability Pre-Assessment
              </Button>
            </Section>
          </Section>

          {/* PAGE CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="main-content">
            <Section className="content-body">
              <Section className="table-filter">
                <InputSearch
                  id="filter_search_input"
                  placeholder="Tax ID, Company Name"
                />

                <SelectBox
                  id="active_status_filter"
                  className="table-filter"
                  options={options}
                  placeholder="Active"
                  isSearchable={false}
                  isClearable={true}
                />
              </Section>

              <Section className="table-wrapper">
                <Table className="sustainability split-row-color">
                  {/* Header Row */}
                  <Table.THEAD>
                    <Table.TR className="header">
                      <Table.TH
                        className="id"
                        id="id_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('ID')}
                        onClick={() => this.toggleSort('ID')}
                      >
                        ID
                      </Table.TH>

                      <Table.TH
                        className="file-name"
                        id="file_name_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('fileName')}
                        onClick={() => this.toggleSort('fileName')}
                      >
                        FILE NAME
                      </Table.TH>

                      <Table.TH className="active" id="active_header">
                        ACTIVE
                      </Table.TH>

                      <Table.TH
                        className="created-date"
                        id="create_date_header"
                      >
                        CREATED DATE
                      </Table.TH>

                      <Table.TH className="actions" id="actions_header">
                        ACTIONS
                      </Table.TH>
                    </Table.TR>
                  </Table.THEAD>

                  {/* Content Row */}
                  <Table.TBODY>
                    <Table.TR>
                      <Table.TD className="id">000001</Table.TD>

                      <Table.TD className="file-name">
                        Pre-Lim Test 2020
                      </Table.TD>

                      <Table.TD className="active">
                        <Switcher
                          onChange={() => this.handleActiveChange('1')}
                          checked={
                            mockUpData
                              .filter(mockUp => {
                                return mockUp.id === '1'
                              })
                              .map(obj => obj.isActive)[0]
                          }
                        />
                      </Table.TD>

                      <Table.TD className="created-date">
                        Oct 08, 2019 14:00
                      </Table.TD>

                      <Table.TD className="actions">
                        <Section>
                          <Button
                            className="link"
                            onClick={() => this.toggleModal()}
                          >
                            <Image
                              className="download-icon"
                              src={ICONS['icon-download.svg']}
                              alt="delete"
                            />
                          </Button>
                        </Section>
                      </Table.TD>
                    </Table.TR>
                  </Table.TBODY>
                </Table>
              </Section>
            </Section>

            <Section className="content-footer">
              <Section className="showing-item">
                Showing 1 to 10 of 60 entries
              </Section>

              <Section className="paginate-wrapper">
                <Paginate
                  activePage={1}
                  itemsCountPerPage={10}
                  totalItemsCount={450}
                  pageRangeDisplayed={5}
                  // onChange={() => ({})}
                />

                <Section className="moveto-wrapper">
                  <Input
                    className="paginate-moveto"
                    label="Page"
                    defaultValue="1"
                    isHorizontal
                    maxLength="4"
                  />

                  <Button>go</Button>
                </Section>
              </Section>
            </Section>
          </Section>
        </SustainabilityPreAssessmentManagementStyled>

        <Modal
          id="delete_id"
          className="theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'delete'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="575px"
        >
          <Modal.Header>Delete</Modal.Header>

          <Modal.Body>
            <p className="default text-center">
              Are you sure to delete? <br />
              {modals[0].FullName}
            </p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              id="close_modal_history_id"
              className="theme-border-gray"
              onClick={() => this.toggleModal('delete')}
            >
              Cancel
            </Button>

            <Button
              id="close_modal_history_id"
              className="theme-green"
              onClick={() => {
                this.deleteList()
              }}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    )
  }
}
